import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import DearExa from "./sections/DearExa";
import ToDearYou from "./sections/ToDearYou";
import FiveLanguagesOfArt from "./sections/FiveLanguagesOfArt";
import PhotographyTherapy from "./sections/PhotographyTherapy";
import RecentLetters from "./sections/RecentLetters";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <DearExa />
      <ToDearYou />
      <FiveLanguagesOfArt />
      <PhotographyTherapy />
      <RecentLetters />
      <Footer />
    </div>;
}